import 'slick-carousel/slick/slick';
import $ from "jquery";

class ProductSingle {
    constructor() {
        let sliderVideos = $('.slider-video');
        let tabs = document.querySelectorAll('.tabs li');
        let iframe = document.querySelectorAll(".iframe-video iframe");

        $('.slider-product').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            rows: 0,
            prevArrow: $('.box-slider-product .btnnavslider .prev'),
            nextArrow: $('.box-slider-product .btnnavslider .next'),
        });

        if ($('.applications-slider .applications-slide').length > 3 || window.matchMedia("(max-width:1024px)").matches) {
            if (window.matchMedia("(max-width:1024px)").matches) {
                $('.applications-slider').slick({
                    dots: false,
                    arrows: true,
                    infinite: false,
                    autoplay: false,
                    variableWidth: true,
                    autoplaySpeed: 3500,
                    speed: 300,
                    slidesToShow: 1,
                });
            }
            else {
                $('.applications-slider').slick({
                    dots: false,
                    arrows: true,
                    infinite: false,
                    autoplay: false,
                    variableWidth: true,
                    autoplaySpeed: 3500,
                    speed: 300,
                    slidesToShow: 3,
                });
            }
        }



        sliderVideos.slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
        });

        sliderVideos.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            iframe.forEach((iframeVideo) => {
                iframeVideo.src = iframeVideo.src;
            })
        });

        for (let tab of tabs) {
            tab.addEventListener('click', function (event) {
                event.preventDefault();
                let datatab = this.dataset.tab;
                inactiveContent();
                this.classList.add('active');
                let contentActive = document.getElementsByClassName(datatab);
                contentActive[0].classList.add('active');

                if ($('.related-news .news-list .post').length > 3) {
                    $('.related-news .news-list').slick({
                        dots: true,
                        arrows: true,
                        infinite: true,
                        slidesToShow: 3,
                        variableWidth: true,
                        rows: 0,
                        prevArrow: $('.related-news .btnnavslider .prev'),
                        nextArrow: $('.related-news .btnnavslider .next'),
                        responsive: [{
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                dots: true,
                            }
                        }]
                    });
                }
            });
        }

        function inactiveContent() {
            for (let tab of tabs) {
                tab.classList.remove('active');
            }

            document.querySelector('.tabs-content .content.active').classList.remove('active');

            iframe.forEach((iframeVideo) => {
                iframeVideo.src = iframeVideo.src;
            })
        }
    }
}

export default ProductSingle;